import { useSyncExternalStore } from 'react'
import { getCookie } from '../lib/cookie'

export const AGENT_COOKIE = '_dd_agent'
export const REFERRER_COOKIE = '_dd_referrer'

export type AgentContext = {
  agent_id: string | undefined
  referrer_user_id: string | undefined
}

const SERVER_SNAPSHOT: AgentContext = {
  agent_id: undefined,
  referrer_user_id: undefined,
}

// 缓存上一次的 snapshot；getSnapshot 是 referentially-stable 时 React useSyncExternalStore
// 才不会触发无限 re-render（`Object.is` 比对）。
let cached: AgentContext = SERVER_SNAPSHOT

function readContext(): AgentContext {
  const agent = getCookie(AGENT_COOKIE)
  // agent == referrer(原值)→ 忽略 referrer(owner 2026-06-28)。
  // 前端无解析能力,仅按 cookie 原值做展示归一化;invited_by 的权威忽略在后端。
  const rawReferrer = getCookie(REFERRER_COOKIE)
  const referrer = agent && rawReferrer === agent ? undefined : rawReferrer
  if (cached.agent_id === agent && cached.referrer_user_id === referrer) {
    return cached
  }
  cached = { agent_id: agent, referrer_user_id: referrer }
  return cached
}

const subscribe = (cb: () => void): (() => void) => {
  if (typeof window === 'undefined') return () => undefined
  const handler = () => {
    // window focus 时强制重读 + 推动 React 重渲（仅当 cookie 真的变了，readContext 会返回新对象）
    readContext()
    cb()
  }
  window.addEventListener('focus', handler)
  return () => window.removeEventListener('focus', handler)
}

const getServerSnapshot = (): AgentContext => SERVER_SNAPSHOT

export function useAgentContext(): AgentContext {
  return useSyncExternalStore(subscribe, readContext, getServerSnapshot)
}
